import { StoredData } from 'frontend/storesV2/types';

export function getDataColumnNames(data: StoredData | null): string[] {
  if (!data) {
    return [];
  }
  return data.columns.map(col => col.name);
}
